import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { GenerateShared } from './../general/shared/generate-shared';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { SnackBarService } from './../../data/repository/utils-repository/snack-bar.service';
import { PlansService } from './../../data/repository/plans-repository/plans.service';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import {
  DietsListCategory,
  DietsListDietType,
} from 'src/app/core/model/api-response/plans-response-model';
import {
  PredefinedDiet,
  PredefinedDietType,
} from 'src/app/core/model/generate-response-model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss'],
})
export class PlansComponent implements OnInit, OnDestroy {
  selectedTab = 1;
  dietsListCategories: DietsListCategory[] = [];
  personalDiet: DietsListDietType;

  dataIsReady = false;

  subscription1: Subscription;
  subscription2: Subscription;

  constructor(
    private plansService: PlansService,
    private planService: PlanService,
    private planShared: PlanShared,
    private generateShared: GenerateShared,
    private snackBarService: SnackBarService
  ) {
    this.getDietsList();

    this.subscription1 = this.planShared.showSecondTabObs$.subscribe((show) => {
      if (show) {
        this.changeTab(1);
      }
    });
    this.subscription2 = this.planShared.showFirstTabObs$.subscribe((show) => {
      if (show) {
        this.changeTab(0);
      }
    });
  }

  ngOnInit() {
    // this.getDiet();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }

  async getDietsList() {
    const response = await this.plansService.getDietsList();
    if (response.isSuccess()) {
      this.dietsListCategories = response.getData().getDietsListCategories();
      this.dietsListCategories = this.dietsListCategories.filter((obj) => {
        if (obj.name === 'رژیم شخصی‌سازی شده') {
          this.personalDiet = obj.dietTypes[0];
        }
        return obj.name !== 'رژیم شخصی‌سازی شده';
      });
      this.dataIsReady = true;
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
    }
  }

  // async getDiet() {
  //   const today = new Date(new Date().setHours(0, 0, 1, 0));
  //   const todayResponse = await this.planService.checkThisDayPlan(today, false, false);
  //   if (todayResponse.isSuccess()) {
  //     if (todayResponse.getData().getType() === 'before') {
  //       console.log('before')
  //     } else if (todayResponse.getData().getType() === 'diet') {
  //       console.log('diet')
  //     } else if (todayResponse.getData().getType() === 'cheatDay') {
  //       console.log('cheat')
  //     } else if (todayResponse.getData().getType() === 'generate') {
  //       console.log('no diet generate')
  //     }
  //   } else {
  //     console.log('no diet')
  //   }
  // }

  personalSelected() {
    // this.generateShared.selectedDietType = new PredefinedDiet(30, '0',
    //   new PredefinedDietType('شما می‌توانید با چند انتخاب، برنامه غذایی مناسب خود را بسازید. هدف برنامه غذایی شما می‌تواند لاغری، چاقی، تثبیت وزن، بارداری یا شیردهی باشد. همچنین برای تمام این برنامه‌ها، گزینه گیاهخواری هم دارید. شما می‌توانید با توجه به سلیقه و مواد غذایی در دسترس خود، برنامه غذایی خود را تغییر دهید و کالری‌شماری انجام دهید. در طول این برنامه غذایی ۳۰ روزه، شما می‌توانید ۲ روز آزاد داشته باشید و به خودتان استراحت دهید.'
    //   , 'assets/generate/personalDiet.png', 'رژیم شخصی سازی شده', '0'));

    // this.generateShared.selectedDietType = new DietsListDietType('', 30, 'شما می‌توانید با چند انتخاب، برنامه غذایی مناسب خود را بسازید. هدف برنامه غذایی شما می‌تواند لاغری، چاقی، تثبیت وزن، بارداری یا شیردهی باشد. همچنین برای تمام این برنامه‌ها، گزینه گیاهخواری هم دارید. شما می‌توانید با توجه به سلیقه و مواد غذایی در دسترس خود، برنامه غذایی خود را تغییر دهید و کالری‌شماری انجام دهید. در طول این برنامه غذایی ۳۰ روزه، شما می‌توانید ۲ روز آزاد داشته باشید و به خودتان استراحت دهید.',
    // null, '0', 'assets/generate/personalDiet.png', true, 'برنامه غذایی خودت را بساز', '');
    this.generateShared.selectedDietType = this.personalDiet;
    this.plansService.goToDietTypeOverview();
  }

  dietTypeSelected(dietType: DietsListDietType) {
    this.generateShared.goal = null;
    this.generateShared.selectedDietType = dietType;
    this.plansService.goToDietTypeOverview();
  }

  changeTab(tabNumber: number) {
    this.selectedTab = tabNumber;
    document.getElementById('tabs-indicator').style.right =
      (tabNumber * 50).toString() + '%';
    if (tabNumber === 0) {
      document.getElementById('plans-tab0').style.right = '0';
      document.getElementById('plans-tab1').style.right = '100%';
    } else if (tabNumber === 1) {
      document.getElementById('plans-tab0').style.right = '-100%';
      document.getElementById('plans-tab1').style.right = '0';
    }
  }
}
